import React, { useEffect, useState } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { Modal, Button, Carousel, Spinner } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { langoptions, relationOptions, pxToCm } from "../../../utils/constants";
import { debouncePromise } from "../../../utils/Debounce";
import { useEditAdLogic } from "./useEditAdLogic";
import config from "../../../config";
import ErrorPreviewModal from "../ErrorPreviewModal";

const EditAdModal = ({ onClose, preFillData, croppedCanvas, imageUrl, originalUrls = [] }) => {
  const {
    register,
    control,
    handleSubmit,
    errors,
    newspapers,
    editions,
    locationNames,
    pageTypes,
    adFormats,
    categories,
    brandlocations,
    loadBrands,
    onSubmit,
    loading,
    uploading,
    setStatus,
    inputFields,
    setInputFields,
    showOriginal,
    setShowOriginal,
    watchBrandType,
    watchBrandLocation,
    color,
    setColor,
    subCategories,
    watchCategoryId,
    watchEdition,
    setValue, handleCloseErrorModal, submitError, showErrorModal
  } = useEditAdLogic({ onClose, preFillData, croppedCanvas,imageUrl, originalUrls });
  
    const [denom,setDenom ] = useState(62)
    useEffect(()=>{
        const val = (watchEdition?.value === 'main' ? config.MAIN_CROP_RATIO : config.OTHER_CROP_RATIO);
        setDenom(val);
    },[watchEdition])

  const brandType = watchBrandType;

  return (
    <>
      {showErrorModal && submitError ?<ErrorPreviewModal show={showErrorModal} onClose={handleCloseErrorModal} errorData={submitError}/> : null}
      {showErrorModal && submitError ? null : <Modal show={true} onHide={onClose} size="xl" centered className="font-sans">
      <Modal.Header closeButton className="border-b border-gray-200 py-3">
        <Modal.Title className="text-lg font-semibold text-gray-800">Edit Ad Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="flex flex-col lg:flex-row gap-6">
          <div className="flex-1">
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
                  <input type="date" className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm" {...register("date", { required: "Required" })} />
                  {errors.date && <p className="text-red-600 text-xs mt-1">{errors.date.message}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Language</label>
                  <Controller name="language" control={control} rules={{ required: "Required" }} render={({ field }) => <Select {...field} options={langoptions} placeholder="Language" />} />
                  {errors.language && <p className="text-red-600 text-xs mt-1">{errors.language.message}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Newspaper</label>
                  <Controller name="newspaper" control={control} rules={{ required: "Required" }} render={({ field }) => <Select {...field} options={newspapers} placeholder="Newspaper" isDisabled={!newspapers.length} />} />
                  {errors.newspaper && <p className="text-red-600 text-xs mt-1">{errors.newspaper.message}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Edition</label>
                  <Controller name="edition" control={control} rules={{ required: "Required" }} render={({ field }) => <Select {...field} options={editions} placeholder="Edition" isDisabled={!editions.length} />} />
                  {errors.edition && <p className="text-red-600 text-xs mt-1">{errors.edition.message}</p>}
                  {preFillData?.pageName && <p className="text-xs text-blue-600 mt-1 font-medium">Page: {preFillData.pageName.label}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Page No</label>
                  <input type="number" className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm" {...register("page_no", { valueAsNumber: true, required: "Required" })} placeholder="Enter Page No" />
                  {errors.page_no && <p className="text-red-600 text-xs mt-1">{errors.page_no.message}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
                  <Controller name="location_name" control={control} render={({ field }) => <Select {...field} options={locationNames} placeholder="Location" isDisabled={!locationNames.length} isClearable />} />
                  {errors.location_name && <p className="text-red-600 text-xs mt-1">{errors.location_name.message}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Page Type</label>
                  <Controller name="page_type" control={control} rules={{ required: "Required" }} render={({ field }) => <Select {...field} options={pageTypes} placeholder="Page Type" isDisabled={!pageTypes.length} />} />
                  {errors.page_type && <p className="text-red-600 text-xs mt-1">{errors.page_type.message}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ad Format</label>
                  <Controller name="ad_format" control={control} rules={{ required: "Required" }} render={({ field }) => <Select {...field} options={adFormats} placeholder="Ad Format" isDisabled={!adFormats.length} />} />
                  {errors.ad_format && <p className="text-red-600 text-xs mt-1">{errors.ad_format.message}</p>}
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="walkin_ads">Walkin Ads</label>
                  <Controller name="walkin_ads" control={control} rules={{ required: false }} render={({ field }) => <input id="walkin_ads" type="checkbox" {...field} />} />
                  {errors.walkin_ads && <p className="text-red-600 text-xs mt-1">{errors.walkin_ads.message}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Campaign Name</label>
                  <input type="text" className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm" {...register("campaign_name", { required: "Required" })} placeholder="Auto-filled from Brand + Ad Format" />
                  {errors.campaign_name && <p className="text-red-600 text-xs mt-1">{errors.campaign_name.message}</p>}
                </div>

                <div className="bg-blue-50 col-span-full border border-blue-200 rounded-lg p-3 flex gap-3 items-center text-sm">
                  <div>
                    <span className="text-gray-500 text-xs">Select edition, location, page type, ad format to get</span>
                    <label className="block font-medium text-blue-900">Estimated Value</label>
                    <input
                      type="text"
                      className="w-full mt-1 px-3 py-2 bg-white border border-blue-300 rounded-md font-semibold text-sm"
                      {...register("estimated_value")}
                      placeholder="Auto-calculated or enter manually" readOnly
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Brand Type</label>
                  <div className="flex gap-4 mt-2 flex-wrap">
                    {["finite", "infinite", "alpha"].map((t) => (
                      <label key={t} className="flex items-center capitalize text-sm">
                        <input type="radio" {...register("brand_type", { required: "Required" })} value={t} className="mr-2" />
                        {t}
                      </label>
                    ))}
                  </div>
                  {errors.brand_type && <p className="text-red-600 text-xs mt-1">{errors.brand_type.message}</p>}
                </div>

                {brandType === "alpha" && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                    <Controller
                      name="category_id"
                      control={control}
                      rules={{ required: brandType === "alpha" ? "Required" : false }}
                      render={({ field }) => <Select {...field} options={categories} placeholder="Category" isDisabled={!categories.length} />}
                    />
                    {errors.category_id && <p className="text-red-600 text-xs mt-1">{errors.category_id.message}</p>}
                  </div>
                )}
                {brandType === "alpha" && watchCategoryId && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Sub Category</label>
                    <Controller
                      name="subcategory_id"
                      control={control}
                      rules={{ required: brandType === "alpha" && watchCategoryId ? "Required" : false }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={subCategories}
                          placeholder="Select Subcategory"
                          isClearable
                          isDisabled={!subCategories.length}
                        />
                      )}
                    />
                    {errors.subcategory_id && <p className="text-red-600 text-xs mt-1">{errors.subcategory_id.message}</p>}
                  </div>
                )}
                {brandType === "alpha" && (
                <div className="flex flex-col items-start justify-center gap-1">
                  <label>Select Event Date</label>
                  <input type='date' onChange={(e)=>setValue('event_date',e.target.value)} className="border-2 border-gray-400 px-2 py-1 rounded-md"/>
                </div>
              )}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Brand Location</label>
                  <Controller
                    name="brand_location"
                    control={control}
                    rules={{ required: brandType !== "alpha" ? "Required" : false }}
                    render={({ field }) => <Select {...field} options={brandlocations} placeholder="Brand Location" isDisabled={!brandlocations.length} />}
                  />
                  {errors.brand_location && <p className="text-red-600 text-xs mt-1">{errors.brand_location.message}</p>}
                </div>

                <div className="col-span-full">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Brand Name</label>
                  <Controller
                    name="brand_name"
                    control={control}
                    rules={{ required: brandType !== "alpha" ? "Required" : false }}
                    render={({ field }) => <AsyncSelect {...field} cacheOptions loadOptions={loadBrands} defaultOptions placeholder="Search Brand..." isClearable isDisabled={!watchBrandLocation?.value || brandType === "alpha"} />}
                  />
                  {errors.brand_name && <p className="text-red-600 text-xs mt-1">{errors.brand_name.message}</p>}
                </div>
              </div>

              {brandType === "alpha" && (
                <div className="border-t pt-5">
                  <h4 className="text-base font-medium mb-3">Advertisers</h4>
                  {inputFields.map((_, i) => (
                    <div key={i} className="border rounded-lg p-3 mb-3 bg-gray-50 relative">
                      {inputFields.length > 1 && (
                        <button type="button" onClick={() => setInputFields(inputFields.filter((_, idx) => idx !== i))} className="absolute top-2 right-2 text-red-600 text-xs hover:underline">
                          Remove
                        </button>
                      )}
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                        <input
                          placeholder="Person Name"
                          className="px-3 py-2 border rounded-md text-sm"
                          value={inputFields[i].person_name || ""}
                          onChange={(e) => {
                            const a = [...inputFields];
                            a[i].person_name = e.target.value;
                            setInputFields(a);
                          }}
                        />
                        <Controller
                          control={control}
                          name={`advertisers[${i}].relation`}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={relationOptions}
                              placeholder="Relation"
                              value={relationOptions.find((o) => o.value === inputFields[i].relation)}
                              onChange={(o) => {
                                field.onChange(o?.value);
                                const a = [...inputFields];
                                a[i].relation = o?.value || 5;
                                setInputFields(a);
                              }}
                            />
                          )}
                        />
                        <input
                          placeholder="Phone"
                          className="px-3 py-2 border rounded-md text-sm"
                          value={inputFields[i].contact || ""}
                          onChange={(e) => {
                            const a = [...inputFields];
                            a[i].contact = e.target.value;
                            setInputFields(a);
                          }}
                        />
                        <input
                          placeholder="Address"
                          className="px-3 py-2 border rounded-md text-sm"
                          value={inputFields[i].address || ""}
                          onChange={(e) => {
                            const a = [...inputFields];
                            a[i].address = e.target.value;
                            setInputFields(a);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                  {inputFields.length < 20 && (
                    <button type="button" onClick={() => setInputFields([...inputFields, { person_name: "", relation: 5, contact: "", address: "" }])} className="text-xs bg-blue-600 text-white px-3 py-1.5 rounded hover:bg-blue-700">
                      + Add Advertiser
                    </button>
                  )}
                </div>
              )}

              <div className="flex justify-end gap-3 mt-6">
                {loading || uploading ? (
                  <div className="px-5 py-2 bg-gray-400 text-white rounded flex items-center gap-2 text-sm">
                    <Spinner animation="border" size="sm" /> {uploading ? "Uploading image..." : "Saving..."}
                  </div>
                ) : (
                  <>
                    <Button variant="outline-danger" onClick={() => setStatus(0)} type="submit" size="sm">
                      Reject
                    </Button>
                    <Button variant="success" onClick={() => setStatus(1)} type="submit" size="sm">
                      Accept & Save
                    </Button>
                  </>
                )}
              </div>
            </form>
          </div>

          <div className="w-full lg:w-80">
            <div className="sticky top-4 bg-gray-50 border rounded-lg p-4 space-y-3">
              <div className="flex items-center justify-between">
                <label className="flex items-center text-sm font-medium text-gray-700">
                  <input type="checkbox" className="mr-2" checked={showOriginal} onChange={() => setShowOriginal(!showOriginal)} />
                  Show Original Page
                </label>
              </div>

              {showOriginal && originalUrls?.length > 0 ? (
                originalUrls.length > 1 ? (
                      <img src={imageUrl} alt="Original" className="w-full rounded border object-contain max-h-80" />
                ) : (
                  <img src={originalUrls[0]} alt="Original" className="w-full rounded border object-contain max-h-80" />
                )
              ) : croppedCanvas ? (
                <div>
                  <img src={croppedCanvas.toDataURL()} alt="Cropped" className="w-full rounded border object-contain max-h-80" />
                  <div className="text-xs text-gray-600 mt-2 grid grid-cols-2 gap-x-4 gap-y-1">
                    <p>Height: {pxToCm(croppedCanvas.height,denom)} cm</p>
                    <p>Width: {pxToCm(croppedCanvas.width,denom)} cm</p>
                    <div className="flex flex-col">
                      <p>Color: {color ? "Color" : "B&W"}</p>
                      <div >
                      <label className="flex items-center gap-2">Color
                        <div onClick={()=>setColor(color ? 0 :1)} className={`h-6 w-11 rounded-full p-1 transition ${color?'bg-blue-600':'bg-gray-300'}`}>
                          <div className={`h-4 w-4 bg-white rounded-full transition ${color?'translate-x-5':''}`}/>
                        </div>
                      </label>
                    </div>
                  </div>
                    <p>Area: {(pxToCm(croppedCanvas.width,denom) * pxToCm(croppedCanvas.height,denom)).toFixed(2)} sqcm</p>
                  </div>
                  <button
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = croppedCanvas.toDataURL("image/png");
                      link.download = "cropped_ad.png";
                      link.click();
                    }}
                    className="mt-3 px-3 py-1.5 bg-green-600 text-white rounded hover:bg-green-700 text-xs"
                  >
                    Download Cropped Image
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
      }
    </>
  );
};

export default EditAdModal;
